<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->

<template>
  <div class="min-h-screen">
    <!-- Header -->
    

    <!-- Hero Section -->
    <section class="relative pt-20">
      <div class="absolute inset-0">
        <img src="https://ai-public.mastergo.com/ai/img_res/c211925d7a31c1ba899d5b91c5462019.jpg"
          class="object-cover object-top w-full h-full" alt="Luxury Real Estate" />
        <div class="absolute inset-0 bg-black bg-opacity-50"></div>
        <div class="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-transparent"></div>
      </div>

      <div class="container relative px-4 py-32 mx-auto">
        <div class="max-w-2xl text-white">
          <h1 class="mb-6 text-5xl font-bold">Smart Real Estate Investment Solutions</h1>
          <p class="mb-8 text-xl">Transform your financial future with strategic property investments. Access exclusive
            opportunities with returns up to 15% annually.</p>
          <button class="!rounded-button bg-white text-blue-900 px-8 py-3 text-lg font-semibold whitespace-nowrap">
            Explore Opportunities
          </button>
        </div>
      </div>
    </section>

    <!-- Story Section -->
    <div class="py-20 bg-gray-50">
      <div class="px-4 mx-auto max-w-7xl">
        <div class="grid items-center gap-12 md:grid-cols-2">
          <div>
            <h2 class="mb-8 text-4xl font-bold">Our Story</h2>
            <p class="mb-6 text-gray-600">Founded in 1995, Luxe Estates has established itself as a pioneer in luxury real estate development. Our journey began with a vision to create extraordinary living spaces that seamlessly blend sophistication with functionality.</p>
            <p class="mb-6 text-gray-600">Over the past 28 years, we've successfully delivered more than 200 premium properties across major metropolitan areas, earning the trust of discerning clients worldwide.</p>
            <div class="flex items-center space-x-8">
              <div class="text-center">
                <div class="text-4xl font-bold text-gray-900">28+</div>
                <div class="text-gray-600">Years Experience</div>
              </div>
              <div class="text-center">
                <div class="text-4xl font-bold text-gray-900">500+</div>
                <div class="text-gray-600">Happy Clients</div>
              </div>
            </div>
          </div>
          <div>
            <img 
              :src="'https://ai-public.mastergo.com/ai/img_res/4c457e275140af85355df9dcae5e4340.jpg'"
              class="w-full rounded-lg shadow-lg"
              alt="Our Office"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Core Values -->
    <div class="py-20 bg-white">
      <div class="px-4 mx-auto max-w-7xl">
        <h2 class="mb-16 text-4xl font-bold text-center">Our Core Values</h2>
        <div class="grid gap-12 md:grid-cols-3">
          <div class="text-center">
            <i class="mb-6 text-4xl text-blue-600 fas fa-gem"></i>
            <h3 class="mb-4 text-xl font-bold">Excellence</h3>
            <p class="text-gray-600">We strive for excellence in every project, ensuring the highest standards of quality and craftsmanship.</p>
          </div>
          <div class="text-center">
            <i class="mb-6 text-4xl text-blue-600 fas fa-handshake"></i>
            <h3 class="mb-4 text-xl font-bold">Integrity</h3>
            <p class="text-gray-600">Trust and transparency form the foundation of our relationships with clients and partners.</p>
          </div>
          <div class="text-center">
            <i class="mb-6 text-4xl text-blue-600 fas fa-lightbulb"></i>
            <h3 class="mb-4 text-xl font-bold">Innovation</h3>
            <p class="text-gray-600">We embrace innovative solutions and sustainable practices in all our developments.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Team Section -->
    <div class="py-20 bg-gray-50">
      <div class="px-4 mx-auto max-w-7xl">
        <h2 class="mb-16 text-4xl font-bold text-center">Our Leadership Team</h2>
        <div class="grid gap-8 md:grid-cols-3">
          <div class="overflow-hidden bg-white rounded-lg shadow-lg">
            <img 
              :src="'https://ai-public.mastergo.com/ai/img_res/a92fc1c2d946493d12d99dc2bfaac67d.jpg'"
              class="object-cover w-full h-64"
              alt="CEO"
            />
            <div class="p-6">
              <h3 class="mb-2 text-xl font-bold">Alexander Mitchell</h3>
              <p class="mb-4 text-gray-600">Chief Executive Officer</p>
              <p class="text-gray-600">With over 25 years of experience in luxury real estate development.</p>
            </div>
          </div>
          <div class="overflow-hidden bg-white rounded-lg shadow-lg">
            <img 
              :src="'https://ai-public.mastergo.com/ai/img_res/dfe3a4b3c19863196578c56c64320ab4.jpg'"
              class="object-cover w-full h-64"
              alt="COO"
            />
            <div class="p-6">
              <h3 class="mb-2 text-xl font-bold">Sarah Chen</h3>
              <p class="mb-4 text-gray-600">Chief Operating Officer</p>
              <p class="text-gray-600">Expert in sustainable development and urban planning.</p>
            </div>
          </div>
          <div class="overflow-hidden bg-white rounded-lg shadow-lg">
            <img 
              :src="'https://ai-public.mastergo.com/ai/img_res/29a79cf4536d385bb4d33115aced80f8.jpg'"
              class="object-cover w-full h-64"
              alt="CFO"
            />
            <div class="p-6">
              <h3 class="mb-2 text-xl font-bold">Marcus Thompson</h3>
              <p class="mb-4 text-gray-600">Chief Financial Officer</p>
              <p class="text-gray-600">Financial strategist with extensive market expertise.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Achievements -->
    <div class="py-20 bg-white">
      <div class="px-4 mx-auto max-w-7xl">
        <div class="grid gap-8 text-center md:grid-cols-4">
          <div>
            <div class="mb-2 text-4xl font-bold text-blue-600">200+</div>
            <div class="text-gray-600">Projects Completed</div>
          </div>
          <div>
            <div class="mb-2 text-4xl font-bold text-blue-600">15</div>
            <div class="text-gray-600">International Awards</div>
          </div>
          <div>
            <div class="mb-2 text-4xl font-bold text-blue-600">500K+</div>
            <div class="text-gray-600">Square Feet Developed</div>
          </div>
          <div>
            <div class="mb-2 text-4xl font-bold text-blue-600">12</div>
            <div class="text-gray-600">Global Offices</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isMenuOpen: false
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    }
  }
};
</script>

<style scoped>
.custom-transition {
  transition: all 0.3s ease-in-out;
}

@media (max-width: 768px) {
  .mobile-menu {
    transform: translateY(-100%);
  }
  
  .mobile-menu.active {
    transform: translateY(0);
  }
}
</style>

